import { useEffect } from "react";
import { pdf } from "@react-pdf/renderer";
import DocA4 from "./Doc/DocA4";

const ComprobantesPDF = ({ header, columns, rows, titlePdf, empresa, trigger, onFinish }) => {
  
  useEffect(() => {
    if (!trigger) return;
    if (!header || !rows) return;

    const abrirPDF = async () => {
      try {
        const blob = await pdf(
          <DocA4
            cabecera={header}
            columns={columns}
            rows={rows}
            titlePdf={titlePdf}
            empresa={empresa}
          />
        ).toBlob();

        const blobUrl = URL.createObjectURL(blob);
        window.open(blobUrl, "_blank");
      } catch (e) {
        console.error("Error generando PDF:", e);
      } finally {
        onFinish(); // resetea el trigger
      }
    };

    abrirPDF();
  }, [trigger]);

  return null;
};

export default ComprobantesPDF;
